// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { ValidatorResult } from "../ui/types/Types";
import { Question } from "../ui/types/SurveyTypes";

export const validate = (questions: Question[]): ValidatorResult => {
  const result: ValidatorResult = {
    validate: true,
    message: ""
  };
  if (questions.length === 0) {
    result.validate = false;
    result.message = "survey.submit.error.no_question";
  } else if (
    questions.length > 0 &&
    questions.find(question => question.label === "" || question.label === null)
  ) {
    result.validate = false;
    result.message = "survey.submit.error.missing_label";
  }
  return result;
};
